const $inject = ['$location', 'authService','$window'];

const authCallbackService = function ($location, authService,$window) {
  let service = {};
  service.checkCallBack = checkCallBack;
  function checkCallBack() {
    const path = $location.$$path;
    if (path && path.includes('access_token=')) {
      const contents = path.substring(path.indexOf('access_token='));
      const parmStr = contents.split('&');
      let parms = [];
      parmStr.forEach((str) => {
        const item = str.split('=');
        if (item.length == 2) {
          parms[item[0]] = item[1];
        }
      });
      if (parms['access_token'] && parms['expires_in']) {
        authService.storeAuth({
          expires_in: parms['expires_in'],
          access_token: parms['access_token'],
          username: getUsername(parms['id_token'])
        });
        const previousState = localStorage.getItem('previousState');
        console.log('authCallbackService.previousState',previousState);
        if (previousState && !previousState.includes('login')) {
          $location.path(previousState);
        }
      }
    }
  }

  function getUsername(jwtToken){
    if(!jwtToken) return;
    
    var parts = jwtToken.split('.');
    if(!parts.length1==3) return;
    try {
      const decodedHeader = JSON.parse($window.atob(parts[0]));
      const decodedPayload = JSON.parse($window.atob(parts[1]));
      const signature = parts[2];
      if(decodedPayload && decodedPayload['https://www.ctmsmart.com/username']){
        return decodedPayload['https://www.ctmsmart.com/username'];
      }

    } catch (e) {
      console.log('Error decoding username: ' + e.message);
    }
  }
  return service;
};

authCallbackService.$inject = $inject;

export default authCallbackService;



// WEBPACK FOOTER //
// ./src/components/lbaAuth0Authenticate/authCallbackService.js